<div class="layout-container">
  <div>
    <h3 class="title">We’re Sorry, You May Not Be Eligible For This Carbon Offset Program</h3>
    <div class="instruction-body sub-title">
      Based on one or more of your responses, your site may not be eligible for this carbon offset program. An email has
      been sent to you with additional information about how to contact us for further discussion.
    </div>
  </div>

  <div>
    <button mat-raised-button color="primary" class="button" type="button" routerLink="/">Return to Home Page</button>
    <div class="button-container">
      <a class="fc-link" routerLink="../eligibility-check">
        <fa-icon [icon]="['far', 'arrow-left']"></fa-icon>
        <span>Back</span>
      </a>
    </div>
  </div>
</div>
